import React from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {useAppSelector} from "../../../../redux/hooks";

const IVRConfigurationDialogInfo = () => {
    const ivrConfigurationData = useAppSelector(state => state.IVRConfigurationReducer.ivrConfigurationData.configuration)

    const nameBodyTemplate = (rowData: any) => {
        let name = rowData?.name;
        const truncateWithEllipses = (text: string, max: number) => {
            return text.substr(0,max-1)+(text.length>max?'...':'');
        }
        if (name) {name = truncateWithEllipses(name, 156)}
        return (
            <React.Fragment>
                <div className="campaignName">
                    <p>{name}</p>
                </div>
            </React.Fragment>
        );
    };

    return (
        <DataTable className="user-dialog-info" value={[ivrConfigurationData]}>
            <Column field="name" header="Назва" body={nameBodyTemplate} className="col-6"></Column>
            <Column field="isActive" header="Стан" body={rowData => rowData?.isActive ? 'Активна' : 'Не активна'} className="col-6"></Column>
        </DataTable>
    )
}

export default IVRConfigurationDialogInfo;

